// extracted by mini-css-extract-plugin
export var bottomText = "SupportSection-module--bottomText--d4f0b";
export var button = "SupportSection-module--button--2dd30";
export var card = "SupportSection-module--card--6398b";
export var cardContent = "SupportSection-module--cardContent--daf2c";
export var cardHeader = "SupportSection-module--cardHeader--5ab8b";
export var cardMeta = "SupportSection-module--cardMeta--10d93";
export var floatingBackground = "SupportSection-module--floatingBackground--ddade";
export var icon = "SupportSection-module--icon--01ef0";
export var root = "SupportSection-module--root--b87c9";